/** The Spanish catalogue for the shot table — the wording only. Why each entry exists is argued in `en/readout.ts`. */
// PROD-CLEANUP: sin consumidor — ver la nota de en/readout.ts.
export default {
  fps: 'FPS',
  weight: 'GRAMAJE',
  hop: 'HOP-UP',
  min: 'MÍNIMA',
  max: 'MÁXIMA',
};
